<template>
<!-- 留言板 -->
  <div >
   <div class="NoShow" :class="{'showBox':showBox}" v-if="true" @click="showBtn"> 留言板  <p class="icon"  :class="{'showIcon':showBox}" ></p></div>
   <div class="messageBox" v-if="showBox">
      <div class="messageTitle">【时空WMS】帮您一站式解决仓储管理问题。（咨询热线：400-991-9533）</div>
      <p class="messageHead">留言咨询 / 申请演示 / 渠道合作</p>
      <form :model="form" @submit.prevent="submit">
      <div class="messageIpt">
        <div class="TptImg"><img src="../../img/inputIcon1.png" alt=""></div>
        <input type="text" v-model.trim="form.Phone"  placeholder="电话（必填）" required @blur="leave(form.Phone)" @focus="getIpt">
        <p  class="hint" v-show="showHint">手机号格式有误</p>
      </div>
      <div class="messageIpt">
        <div class="TptImg"><img src="../../img/inputIcon2.png" alt=""></div>
        <input type="text" v-model.trim="form.Name"  placeholder="称呼（必填）" required>
      </div>
      <div class="messageIpt">
        <div class="TptImg"><img src="../../img/inputIcon4.png" alt=""></div>
        <input type="text" v-model.trim="form.CompanyName" placeholder="公司名称">
      </div>
      <div class="messageIpt">
        <div class="TptImg"><img src="../../img/inputIcon3.png" alt=""></div>
        <input type="text" v-model.trim="form.content"  placeholder="留言内容">
      </div>
      <div class="inputBtn">
        <button>提交</button>
      </div>
      </form>
   </div>
  </div>
</template>

<script>
import { setMessage } from '@/api/navbar.js'
export default {
  data () {
    return {
      showBox: true,
      form: {},
      showHint: false // 手机格式错误显示
    }
  },
  methods: {
    showBtn () {
      this.showBox = !this.showBox
      this.form = {}
      this.showHint = false
    },
    // 获取焦点
    getIpt () {
      this.showHint = false
    },
    // input失去焦点校验
    leave (data) {
      // console.log(data, 'data')
      const tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (tel.test(data)) {
        // console.log('1111111')
        this.showHint = false
      } else {
        // console.log('22222222')
        this.showHint = true
      }
    },
    async submit () {
      console.log('this.form', this.form)
      // 手机格式错误返回
      if (this.showHint) {
        return false
      }
      // 表格空返回
      if (JSON.stringify(this.form) === '{}') {
        return false
      }
      const phone = this.form.Phone
      // 手机和名字空返回
      if (!phone) {
        console.log('手机空')
        return false
      }
      const name = this.form.Name
      if (!name) {
        console.log('mingzi kong')
        return false
      }
      // console.log('请求')
      const res = await setMessage(this.form)
      // console.log('表单提交后', res)
      if (res.Code === 0) {
        this.$message({
          message: '恭喜你,提交成功',
          type: 'success'
        })
        this.form = {}
        this.showBox = false
      }
      this.form = {}
      this.showBox = false
    }
  }

}
</script>

<style lang="scss" scoped>
$sun:100/192;
.NoShow{
width: 284px*$sun;
height: 55px*$sun;
line-height: 55px*$sun;
background: #2380E1;
box-shadow: 0px*$sun 3px*$sun 6px*$sun rgba(0,0,0,0.25);
border-radius: 8px*$sun;
font-size: 16px*$sun;
font-weight: 500;
color: #FFFFFF;
padding:0 20px*$sun;
cursor: pointer;
.icon{
  float: right;
  border: 3px*$sun solid #FFFFFF;
width: 18px*$sun;
height: 14px*$sun;
margin: 19px*$sun 0;
}
.showIcon{
  width: 18px*$sun;
  height:0;
  margin: 26px*$sun 0;
  background: #FFFFFF;
  border: 2px*$sun solid #FFFFFF;
}
}
.showBox{
border-radius: 8px*$sun 8px*$sun 0px 0px;
box-shadow: 0px*$sun 0 0 ;
}
.messageBox::-webkit-scrollbar{
				display: none;
			}
.messageBox{
width: 284px*$sun;
height: 414px*$sun;
font-size: 16px*$sun;
font-weight: 500;
background: #FFFFFF;
box-shadow: 0px 6px 10px rgba(0,0,0,0.25);
border-radius: 0px*$sun 0px*$sun 10px*$sun 10px*$sun;
overflow: hidden;
overflow-y: scroll;
  .messageTitle{
    width: 250px*$sun;
    // height: 67px*$sun;
    // line-height: 23px*$sun;
    color: #333333;
    margin: 10px*$sun auto;
    overflow: hidden;
  }
  .messageHead{
    width: 250px*$sun;
    margin: 0 auto;
    margin-bottom: 25px*$sun;
    overflow: hidden;
  }
  .messageIpt{
    width: 250px*$sun;
    height: 42px*$sun;
    margin: 15px*$sun auto;
    font-size: 14px*$sun;
    font-weight: 500;
    border: 2px*$sun solid #DCDFE6;
    border-radius: 4px*$sun;
    position: relative;
    .TptImg{
      float: left;
      display: inline-block;
      width: 14px*$sun;
      height: 14px*$sun;
      margin: 14px*$sun;
      img{
        width: 100%;
        height: 100%;
      }
    }
    input{
      float: right;
      border: none;
      cursor: pointer;
      width: 200px*$sun;
      height: 100%;
      outline: none;
    }
    .hint{
      position: absolute;
      right: 5px*$sun;
      color: red;
    }
  }
  .inputBtn{
    width: 250px*$sun;
    height: 42px*$sun;
    margin: 15px*$sun auto;
    button{
      float: right;
      /* 清除默认边框 */
      border:0;
      outline:none;
      /*清除默认背景 */
      background-color: transparent;
      color: #FFFFFF;
      background: #2380E1;
      font-size: 14px*$sun;
       font-weight: 500;
      width: 76px*$sun;
       height: 38px*$sun;

    }
  }
}
</style>
